import { FaAngleRight } from "react-icons/fa";

export const SidebarData = [
    {
        title: 'kurung collection',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            {
                title: 'hijabistahub collection',
                subSubNav: [
                    { title: 'classic embroidery kurung' },
                    { title: 'drape kurung pattern' },
                    { title: 'modern kurung' }
                ]
            },
            {
                title: 'wawa zainal x hijabistahub',
                subSubNav: [
                    { title: 'dianna kurung' },
                    { title: 'nastiya kurung' },
                    { title: 'sareema kebaya' },
                    { title: 'widuri kurung' },
                    { title: 'wawa zainal for kids' }
                ]
            },
            // {
            //     title: 'adira salahudi x hijabistahub',
            //     subSubNav: [
            //         { title: 'alva kurung' },
            //         { title: 'deera kurung' },
            //         { title: 'velisa kurung kedah' }
            //     ]
            // }
        ]
    },
    {
        title: 'men collection',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            { title: 'adam kurta for kids' },
            { title: 'aeril zafrel baju melayu' },
            // { title: 'aeril zafrel for kids' },
            // { title: 'idris kurta' },
            // { title: 'idris kurta for kids' },
            // { title: 'qaiser baju melayu' },
            // { title: 'adam kurta' }
        ]
    },
    {
        title: 'abaya series',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            {
                title: 'inayra series',
                subSubNav: [
                    { title: 'aleena pleated abaya' },
                    { title: 'aleena pleated abaya for kids' },
                    { title: 'atifa abaya' },
                    { title: 'auliya abaya' },
                    { title: 'eryna abaya' },
                    { title: 'hayaa abaya' },
                    { title: 'inaaya abaya' },
                    { title: 'kairina abaya' },
                    { title: 'safaa abaya' },
                    { title: 'safaa abaya for kids' },
                    { title: 'wadina abaya' }
                ]
            },
            {
                title: 'faith series',
                subSubNav: [
                    { title: 'aafiya abaya' },
                    { title: 'afsha khimar' },
                    { title: 'ajwa abaya' },
                    { title: 'bilqis abaya' },
                    { title: 'medina khimar' },
                    { title: 'raudhan abaya' },
                    { title: 'syifa abaya' }
                ]
            },
        ]
    },
    {
        title: 'bride series',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            {
                title: 'bridesmaid collection',
                subSubNav: [
                    { title: 'adra kurung' },
                    { title: 'damia kurung' }
                ]
            },
            {
                title: 'kurung pahang',
                subSubNav: [
                    { title: 'amanda kurung' },
                    { title: 'amani kebaya' },
                    { title: 'andayani kurung' },
                    { title: 'marwa kebaya' },
                    { title: 'merida kurung' },
                    { title: 'mila kebaya' },
                    { title: 'nastasya kurung' },
                    { title: 'zahra kurung' },
                    { title: 'inessa kurung' },
                    { title: 'grace kurung' }
                ]
            },
            // {
            //     title: 'kurung moden',
            //     subSubNav: [
            //         { title: 'sareena bride kurung' },
            //         { title: 'wilda kebaya' },
            //         { title: 'salma kurung' },
            //         { title: 'dinara kurung' },
            //         { title: 'natalya kurung' },
            //         { title: 'caterina kurung' },
            //         { title: 'ophelia kurung' }
            //     ]
            // },
            // {
            //     title: 'mini kurung',
            //     subSubNav: [
            //         { title: 'lynda kurung' },
            //         { title: 'mellisa kurung' },
            //         { title: 'saira kurung' }
            //     ]
            // },
            // {
            //     title: 'bride series (dress)',
            //     subSubNav: [
            //         { title: 'belinda dress' },
            //         { title: 'juliana dress' },
            //         { title: 'karina dress' },
            //         { title: 'trail' },
            //         { title: 'josephine dress' },
            //         { title: 'jacqueline dress' },
            //         { title: 'evangeline dress' },
            //         { title: 'demica dress' },
            //         { title: 'angelica dress' }
            //     ]
            // },
            // {
            //     title: 'accessories',
            //     subSubNav: [
            //         { title: 'crown' },
            //         { title: 'garment bag' },
            //         { title: 'hijabistahub box' },
            //         { title: 'veil' },
            //         { title: 'heels collection' },
            //         { title: 'selendang & shoes' }
            //     ]
            // },
        ]
    },
    {
        title: 'dress & casual wear',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            {
                title: 'magnificent series',
                subSubNav: [
                    { title: 'amora' },
                    { title: 'blazzers' },
                    { title: 'tamara dress' },
                    { title: 'tutu skirt' },
                    { title: 'darina top' },
                    { title: 'glenda top' },
                    { title: 'pleated satin skirt' },
                    { title: 'palazo pants' }
                ]
            },
            {
                title: 'petals series',
                subSubNav: [
                    { title: 'everlast collection' },
                    { title: 'peony dress' }
                ]
            },
            // {
            //     title: 'precious series',
            //     subSubNav: [
            //         { title: 'elsie top' },
            //         { title: 'jules suit' },
            //         { title: 'oceana suit' }
            //     ]
            // },
            // {
            //     title: 'airy series',
            //     subSubNav: [
            //         { title: 'delia dress' },
            //         { title: 'everly dress' },
            //         { title: 'hazel dress' },
            //         { title: 'bianca pleated dress' },
            //         { title: 'claudia dress' },
            //         { title: 'tierra pants' },
            //         { title: 'viola pleated' },
            //         { title: 'matilda dress' },
            //         { title: 'quinn dress' },
            //     ]
            // },
        ]
    },
    {
        title: 'headscarf',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            {
                title: 'hijabistahub x asyalliee',
                subSubNav: [
                    { title: 'syasya bawal bridal' },
                    { title: 'syasya bawal drape' }
                ]
            },
            { title: 'bawal helena' },
            // { title: 'thalia shawl' },
            // { title: 'eva pleated shawl' }
        ]
    },
    {
        title: 'nvdisms beauty',
    },
    {
        title: 'as is item',
        iconNext: <FaAngleRight/>,
        subNav: [
            { title: 'show all' },
            { title: 'off season collection' },   
        ]
    }
]